import React, { useEffect, useState } from 'react'

import { CircularProgress } from "@material-ui/core";
import { Link } from "react-router-dom";
import '../assets/css/style.css';
import '../style/HomeScreen.css'
import "react-multi-carousel/lib/styles.css";
import Carousel from 'react-multi-carousel';
import { useHistory } from "react-router-dom";


const HomeScreenUI = ({ isLoading, news }) => {

  const [links, setlinkJson] = useState()
  useEffect(() => {
    fetch(`${window.location.origin}/app/rbilandinglinks.json`)
      .then((res) => {
        return res.json()
      }).then((data) => {
        setlinkJson(data)

      }).catch(err => console.log(err));
  }, []);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 600 },
      items: 2,
      slidesToSlide: 2

    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
  };
  let history = useHistory();







  return (
    <main id="main">
      <section id="highlight" className="highlights">
        <div className="container">


          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlaySpeed={10000} autoPlay={true}
            showDots
            arrows={false}
            // slidesToSlide={3}
            renderButtonGroupOutside={true}
            itemClass='col-md-12 col-lg-12 pt-4 item'
            containerClass='content highlights-margin'>

            <div id="pi" title="Click to know more" onClick={() => { history.push('/FaqPrimaryIssuances') }}>
              <i className="ri-auction-line"></i>
              <h3>Primary Issuances</h3>
              <p className="font-normal">
                Primary issuances are first time issuances or re-issuances
                of government securities by Central Government or State
                Governments.
              </p>
              <span className="txt-more">
                {" "}
                more <i className="ri-arrow-right-s-line"></i>
              </span>
            </div>

            <div id="gb" title="Click to know more" onClick={() => { history.push('/FaqGoldBonds') }}>
              {/* <!-- <i className="ri-safe-line"></i> --> */}
              <i className="ri-coin-line"></i>
              <h3>Sovereign Gold Bonds</h3>
              <p className="font-normal">
                Sovereign Gold Bonds are considered to be substitutes for
                holding physical gold and are government securities
                denominated in grams of gold.
              </p>
              <span className="txt-more">
                {" "}
                more <i className="ri-arrow-right-s-line"></i>
              </span>
            </div>



            <div id="fr" title="Click to know more" onClick={() => { history.push('/FaqFrsb') }}>
              {/* <i className="ri-auction-line"></i> */}
              <i className="ri-award-fill"></i>
              <h3>Floating Rate Savings Bond 2020</h3>
              <p className="font-normal">
                FRSB 2020 issued by Govt of India offers an investment option
                with interest rate linked to the prevailing National Saving Certificate rate plus a
                spread of 0.35%.
              </p>
              <span className="txt-more">
                {" "}
                more <i className="ri-arrow-right-s-line"></i>
              </span>
            </div>



            <div id="sm" title="Click to know more" onClick={() => { history.push('/FaqNdsOmSecondaryMarket') }}>
              <i className="ri-line-chart-line"></i>
              <h3>NDS-OM Secondary Market</h3>
              <p className="font-normal">
                NDS-OM is RBI's screen based, anonymous electronic order
                matching system for trading in G-Sec in the secondary
                market.
              </p>
              <span className="txt-more">
                {" "}
                more <i className="ri-arrow-right-s-line"></i>
              </span>
            </div>



            <div id="rd" title="Click to know more" onClick={() => { history.push('/FaqRbiRetailDirect') }}>
              {/* <!-- <i className="ri-user-6-line"></i> --> */}
              <i className="ri-user-shared-line"></i>
              <h3>RBI Retail Direct</h3>
              <p className="font-normal">
                Retail Direct scheme is a one-stop solution to facilitate
                investment in Government Securities by Individual Investors.
              </p>
              <span className="txt-more">
                {" "}
                more <i className="ri-arrow-right-s-line"></i>
              </span>
            </div>



            {/* <div id="gs" title="Click to know more" onClick={() => { history.push('/FaqGovernmentSecurities') }}>
              <i className="ri-government-line"></i>
              <h3>Government Securities</h3>
              <p className="font-normal">
                A Government Security (G-Sec) is a tradable instrument
                issued by the Central Government or the State Governments.
              </p>
              <span className="txt-more">
                {" "}
                more <i className="ri-arrow-right-s-line"></i>
              </span>
            </div> */}











          </Carousel>

        </div>
      </section >

      <section id="latest" className="details">
        <div className="container">
          <div className="row content">
            <div className="col-md-12 col-lg-6 pt-4 market">
              <div className="section-title">
                <h2>Market Rates</h2>
              </div>
              <p className="font-normal">
                <a
                  // href="https://www.ccilindia.com/Research/Statistics/Pages/TenorwiseIndicativeYields.aspx"
                  href={links?.tenorHanging}
                  target="_blank" title="Link will open in new Tab">
                  Tenor-wise Indicative Yields{" "}
                  <i className="ri-external-link-line" style={{ verticalAlign: "-3px" }}></i>
                </a>
              </p>

              <p className="font-normal" style={{ marginTop: "50px" }}>
                Check latest market rates on <br />
                <a
                  // href="https://www.ccilindia.com/OMHome.aspx"
                  href={links?.rbiNdsOm}
                  target="_blank"
                  title="Link will open in new Tab">
                  NDS-OM Market Watch Page{" "}
                  <i className="ri-external-link-line" style={{ verticalAlign: "-3px" }}></i>
                </a>
              </p>
            </div>

            <div className="col-md-12 col-lg-6 p-4 news">
              <div className="section-title">
                <h2>Whats's New?</h2>
              </div>
              <div style={{ marginBottom: ".5rem", overflowY: "auto" }}>
                {isLoading ? (
                  <div style={{ height: "70px", marginTop: "5%", marginLeft: "50%", }}>
                    <CircularProgress variant="indeterminate" value={100} size={50} color={"inherit"} />
                  </div>
                ) : (
                  <ul style={{ height: "80px" }}>
                    {news &&
                      news.map((element, index) => (
                        <li key={index}>
                          <i className="ri-file-pdf-line"></i>{" "}
                          <a href={element.newsURL} target="_blank">
                            {element.title}
                          </a>
                        </li>
                      ))}
                  </ul>
                )}
                {/* <ul style={{height:'80px'}}>
                            <li>
                                <i className="ri-file-pdf-line"></i>{" "}
                                <a href={PDF1} target="_blank">
                                    Auction of Government of India Dated Securities
                                </a>
                            </li>
                            <li>
                                <i className="ri-file-pdf-line"></i>{" "}
                                <a href={PDF2} target="_blank">
                                    91 days, 182 days and 364 days Treasury Bills auction
                                </a>
                            </li>
                            <li>
                                <i className="ri-file-pdf-line"></i>{" "}
                                <a href={PDF3} target="_blank">
                                    Government Stock - Full Auction Results
                                </a>
                            </li>
                        </ul>*/}
              </div>
              <span className="btn-more" style={{ marginTop: "15px" }}>
                <Link to="/News">
                  {" "}
                  more <i className="ri-arrow-right-s-line"></i>
                </Link>
              </span>
            </div>
          </div>
        </div>
      </section>
    </main >)
}; export default HomeScreenUI